import { toast } from "react-toastify";

export const errorHandler = (errorModel: any): void => {
  if (errorModel.message) {
    toast.error(errorModel.message);
  }
};
